import { Fragment } from 'react'

import { splitByMatch } from '../Filters.utils'
import cn from './HighlightText.module.scss'

type HighlightTextProps = {
  text: string
  query: string
}

function HighlightText({ text, query }: HighlightTextProps) {
  const segments = splitByMatch(text, query)

  return (
    <>
      {segments.map((segment, index) =>
        segment.matched ? (
          <mark key={index} className={cn.highlight}>
            {segment.text}
          </mark>
        ) : (
          <Fragment key={index}>{segment.text}</Fragment>
        )
      )}
    </>
  )
}

export default HighlightText
